import type { GiantId } from '../../../../../../domain/ids/ids';
import drakochiImg from './drakochi.png';
import duckImg from './duck.png';
import factorImg from './factor.png';
import monaImg from './mona.png';
import muImg from './mu.png';
import rozaImg from './roza.png';
import serjImg from './serj.png';
import solImg from './sol.png';
import svamiImg from './svami.png';
import willyImg from './willy.png';
import yettiImg from './yetti.png';
import drakochiBadgeImg from './badges/drakochi-b.png';
import duckBadgeImg from './badges/duck-b.png';
import factorBadgeImg from './badges/factor-b.png';
import monaBadgeImg from './badges/mona-b.png';
import muBadgeImg from './badges/mu-b.png';
import rozaBadgeImg from './badges/roza-b.png';
import serjBadgeImg from './badges/serj-b.png';
import solBadgeImg from './badges/sol-b.png';
import svamiBadgeImg from './badges/svami-b.png';
import willyBadgeImg from './badges/willy-b.png';
import yettiBadgeImg from './badges/yetti-b.png';

export const GIANT_ICONS: Record<GiantId, string> = {
  roza: rozaImg,
  drakochi: drakochiImg,
  factor: factorImg,
  mona: monaImg,
  yetti: yettiImg,
  duck: duckImg,
  svami: svamiImg,
  serj: serjImg,
  willy: willyImg,
  sol: solImg,
  mu: muImg,
};

/** Circular badge arts (Figma "badges") — used on new/success delivery screens. */
export const GIANT_BADGE_ICONS: Record<GiantId, string> = {
  roza: rozaBadgeImg,
  drakochi: drakochiBadgeImg,
  factor: factorBadgeImg,
  mona: monaBadgeImg,
  yetti: yettiBadgeImg,
  duck: duckBadgeImg,
  svami: svamiBadgeImg,
  serj: serjBadgeImg,
  willy: willyBadgeImg,
  sol: solBadgeImg,
  mu: muBadgeImg,
};

export function getGiantIconAssetUrls(): string[] {
  return Object.values(GIANT_ICONS);
}

export function getGiantBadgeIconAssetUrls(): string[] {
  return Object.values(GIANT_BADGE_ICONS);
}
